<template>
    <div @click="hide" v-if="visible" class="shareTip">
        <img src="https://picbed.qunarzz.com/786cf372b62602dd0727dd2c446909d0.png" alt="">
    </div>
</template>

<script>
    export default {
        data(){
            return {
                visible:false
            }
        },
        methods:{
            show(){
                this.visible = true;
            },
            hide(){
                this.visible = false;
            }
        }
    }
</script>

<style lang="less" scoped="true">
    .shareTip{
        position: fixed;
        left:0;
        top:0;
        width:100%;
        height:100%;
        background-color:rgba(0,0,0,.6);
        z-index: 99999;
        img{
            width: 60%;
            display: block;
            position: absolute;
            /* right: 0; */
            left: 20%;
            top: 40px;
        }
    }
</style>